























































import { Vue, Component, Prop } from 'vue-property-decorator';

import FormLayout from './FormLayout.vue';
import DataList from '../../list/DataList.vue';
import DataItem from '../../list/DataItem.vue';
import PhoneDisplay from '../../PhoneDisplay.vue';

import StepInputTime from '@/components/calendar/StepInputTime.vue';
import StepInputDuration from '@/components/calendar/StepInputDuration.vue';
import BaseBadge from '@/components/badge/BaseBadge.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { formatDateForInput } from '@/utils/date';

import { ReservedSlot } from '../types';
import { humanizeToRussian } from '@/utils/date/human';

@Component({
    components: {
        FormLayout,
        DataList,
        DataItem,
        PhoneDisplay,
        StepInputTime,
        StepInputDuration,
        BaseBadge,
        BaseButton,
    },
})
export default class FormReserved extends Vue {
    @Prop({ required: true }) event!: ReservedSlot

    duration = 90;

    get humanDuration() {
        return humanizeToRussian(this.duration);
    }

    get date() {
        return formatDateForInput(this.event.start);
    }

    get startTime() {
        if (!this.event?.start) {
            return '';
        }
        
        return this.getConsultationTime(this.event.start);
    }

    get startTimeInMinutes() {
        if (!this.startTime) {
            return '';
        }

        const startTime = this.getConsultationTime(this.startTime);
        const startTimeInMinutes = this.convertTimeToMinutes(startTime);
        
        return startTimeInMinutes ?? 0;
    }

    get endTime() {
        if (!this.event?.end) {
            return '';
        }
        
        return this.getConsultationTime(this.event.end);
    }

    get endTimeInMinutes() {
        if (!this.endTime) {
            return '';
        }

        const endTime = this.getConsultationTime(this.endTime);
        const endTimeInMinutes = this.convertTimeToMinutes(endTime);
        
        return endTimeInMinutes ?? 0;
    }

    getConsultationTime(time: string) {
        const matchArray = time.match(/\d\d:\d\d/);

        return matchArray ? matchArray[0] : '';
    }

    convertTimeToMinutes(time: string) {
        if (!time) {
            return '';
        }

        const splitted = time.split(':');
        const timeInMinutes = (+splitted[0] * 60) + +splitted[1];
        
        return timeInMinutes ?? 0;
    }

    openConsultation() {
        const { id } = this.event.consultation;

        this.$router.push({ name: 'consultation', params: { id }})
    }

    removeConsultation() {
        this.$emit('remove');
    }

    created() {
        if (this.endTimeInMinutes && this.startTimeInMinutes) {
            this.duration =  this.endTimeInMinutes - this.startTimeInMinutes;
        }
    }
}
